module.exports = __webpack_public_path__ + "img/Solutions-EstatePlanningServices.0c7ba7f1.jpg";